import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { ArrowRight, Phone, TriangleAlert } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TransitionLink } from '@/components/generals/transition-link'
import { siteConfig, QUOTE_PATH } from '@/constants/site'

const isTypingTarget = (target: EventTarget | null): boolean =>
    target instanceof HTMLElement && target.matches('input, textarea, select')

export const MobileActionBar: FC = (): ReactNode => {
    const [typing, setTyping] = useState(false)

    useEffect(() => {
        const handleFocusIn = (event: FocusEvent) => setTyping(isTypingTarget(event.target))
        const handleFocusOut = () => setTyping(false)

        window.addEventListener('focusin', handleFocusIn)
        window.addEventListener('focusout', handleFocusOut)

        return () => {
            window.removeEventListener('focusin', handleFocusIn)
            window.removeEventListener('focusout', handleFocusOut)
        }
    }, [])

    return (
        <nav
            aria-label="Quick actions"
            className={cn(
                'fixed inset-x-3 bottom-3 z-40 grid grid-cols-3 gap-1.5 rounded-[22px] border border-white/10 bg-ink/90 p-1.5 shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)] backdrop-blur-xl transition-[transform,translate,scale,rotate,opacity] duration-500 ease-expo md:hidden',
                typing ? 'pointer-events-none translate-y-[140%] opacity-0' : 'translate-y-0 opacity-100'
            )}
        >
            <a
                href={siteConfig.phoneHref}
                className='flex h-12 items-center justify-center gap-2 rounded-2xl text-[13.5px] font-medium text-cream transition-colors active:bg-white/10'
            >
                <Phone className='size-4' aria-hidden='true' />
                Call
            </a>

            <TransitionLink
                href='/services/emergency-repair'
                className='flex h-12 items-center justify-center gap-2 rounded-2xl text-[13.5px] font-medium text-cream transition-colors active:bg-white/10'
            >
                <TriangleAlert className='size-4 text-ember-soft' aria-hidden='true' />
                Emergency
            </TransitionLink>

            <TransitionLink
                href={QUOTE_PATH}
                className='flex h-12 items-center justify-center gap-2 rounded-2xl bg-ember text-[13.5px] font-medium text-white transition-colors active:bg-ember-deep'
            >
                My price
                <ArrowRight className='size-4' aria-hidden='true' />
            </TransitionLink>
        </nav>
    )
}
